import PropTypes from 'prop-types';
import { useEffect, useRef } from 'react';

import { useApplicationStore } from './applicationStore';

const WaitListModal = ({ isOpen = false, onContinue, onCancel }) => {
	const modalRef = useRef();
	const { program } = useApplicationStore();
	useEffect(() => {
		if (isOpen) {
			modalRef.current.showModal();
		}
	}, [isOpen]);

	return (
		<dialog id="confirm-release" className="modal" ref={modalRef}>
			<div className="modal-box">
				<h3>Join Wait List?</h3>
				<p className="py-4">
					{program?.locations[0].organization_name} has a wait list for{' '}
					{program?.name}.
				</p>
				<div className="modal-action">
					<form method="dialog">
						<button className="btn" onClick={onCancel}>
							Cancel
						</button>
						<button className="ml-4 btn" onClick={onContinue}>
							Add to Wait List
						</button>
					</form>
				</div>
			</div>
		</dialog>
	);
};

WaitListModal.propTypes = {
	isOpen: PropTypes.bool,
	onContinue: PropTypes.func.isRequired,
	onCancel: PropTypes.func.isRequired,
};

export default WaitListModal;
